<script setup lang="ts">
// Any emoji as a reaction: a grid of common ones, or type one from the keyboard's emoji picker.
import { computed, ref } from 'vue'
import { MORE_REACTIONS, singleEmoji } from '../lib/annotations'
import Modal from './Modal.vue'

const emit = defineEmits<{ pick: [emoji: string]; close: [] }>()
const typed = ref('')
const valid = computed(() => singleEmoji(typed.value))

function pick(emoji: string): void {
  emit('pick', emoji)
  emit('close')
}
</script>

<template>
  <Modal title="React" @close="emit('close')">
    <div class="grid grid-cols-8 gap-1" data-testid="emoji-grid">
      <button
        v-for="r in MORE_REACTIONS"
        :key="r"
        class="aspect-square text-xl hover:bg-bg-hover"
        :aria-label="`React ${r}`"
        @click="pick(r)"
      >
        {{ r }}
      </button>
    </div>
    <form class="mt-4 flex gap-2" @submit.prevent="valid && pick(valid)">
      <input
        v-model="typed"
        class="input"
        placeholder="Or type any emoji"
        aria-label="Type any emoji"
        maxlength="16"
        data-testid="emoji-input"
      />
      <button class="btn-primary" :disabled="!valid" data-testid="emoji-submit">React</button>
    </form>
  </Modal>
</template>
